import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
// import BgPicker from "./BgPicker";
import HpcFoundational from "./hpcFoundational/hpcFoundational";
import HpcMiddle from "./hpcMiddle/hpcMiddle";
import HpcPreperatory from "./hpcPreperatory/hpcPreperatory";


const HpcStudentSlider = (props) => {
    const [cbox1, setCbox1] = useState(true)
    const [cbox2, setCbox2] = useState(true)
    const [cbox3, setCbox3] = useState(true)
    const [cbox4, setCbox4] = useState(true)
    const [cbox5, setCbox5] = useState(true)
    const [partAColor, setPartAColor] = useState('#5e35b1')
    const [partBColor, setPartBColor] = useState('#fee4a4')
    // const [flgWing, setFlgWing] = useState(20);
    useEffect(() => {
        // console.log('HpcStudentSlider=', props)
        cbCbox()
    }, [cbox1, cbox2, cbox3, cbox4, cbox5]);

    const handleCbox = async (e, pVal) => {
        // console.log(e.target.checked, pVal)
        if (pVal == 1) {
            await setCbox1(e.target.checked);
        }
        if (pVal == 2) {
            await setCbox2(e.target.checked);
        }
        if (pVal == 3) {
            await setCbox3(e.target.checked);
        }
        if (pVal == 4) {
            await setCbox4(e.target.checked);
        }
        if (pVal == 5) {
            await setCbox5(e.target.checked);
        }
    }
    const cbCbox = () => {
        // console.log(cbox1, cbox2, cbox3, cbox4, cbox5)
    }

    return (
        <div>
            <ToastContainer autoClose={3000} hideProgressBar />
            <div style={{ width: "100%", textAlign: "center", margin: 0 }}>
                <button
                    type="button"
                    className="btn btn-info text-center "
                    style={{ right: "80%" }}
                    id="closeSlider"
                    onClick={props.closeSlider}
                >
                    <span
                        id="close"
                        title="Close Slider"
                        className="glyphicon glyphicon-remove"
                    ></span>
                </button>


                <div className="col-sm-12 padding-remove" style={{ marginBottom: 5 }}>
                    {props.hpcFormat == 10 ? <form>
                        <div className="col-sm-8">
                            <div className="col-sm-3">
                                <label className="control-label" htmlFor="PartA1">Part-A(1)</label>
                                <div className="form-group">
                                    <input type="checkbox" checked={cbox1} onClick={(e) => handleCbox(e, 1)} />
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <label className="control-label" htmlFor="PartA2">Part-A(2)</label>
                                <div className="form-group">
                                    <input type="checkbox" defaultChecked={cbox2} onClick={(e) => handleCbox(e, 2)} />
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <label className="control-label" htmlFor="PartB">Part-B</label>
                                <div className="form-group">
                                    <input type="checkbox" defaultChecked={cbox3} onClick={(e) => handleCbox(e, 3)} />
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <label className="control-label" htmlFor="PartC">Part-C</label>
                                <div className="form-group">
                                    <input type="checkbox" defaultChecked={cbox4} onClick={(e) => handleCbox(e, 4)} />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-2" >
                            <label className="control-label text-center" htmlFor="Part-A Color">Part-A Color</label>
                            <div className="form-group col-sm-12">
                                <input type="color" list="presetColors1" className="form-control" onChange={e => setPartAColor(e.target.value)} defaultValue={partAColor} id="partAColor" />
                                <datalist id="presetColors1">
                                    <option>#5e35b1</option>
                                    <option>#b1357d</option>
                                    <option>#3d35b1</option>
                                    <option>#35b137</option>
                                    <option>#b17d35</option>
                                    <option>#b13535</option>
                                    <option>#ffdd00</option>
                                </datalist>
                            </div>
                        </div>
                        <div className="col-sm-2">
                            <label className="control-label text-center" htmlFor="Part-A Color">Part-B Color</label>
                            <div className="form-group col-sm-12">
                                <input type="color" list="presetColors2" className="form-control" onChange={e => setPartBColor(e.target.value)} defaultValue={partBColor} id="partBColor" />
                                <datalist id="presetColors2">
                                    <option>#fee4a4</option>
                                    <option>#c6ebc6</option>
                                    <option>#e3caec</option>
                                    <option>#cbdbec</option>
                                    <option>#eccbd8</option>
                                    <option>#eeeeee</option>
                                </datalist>
                            </div>
                        </div>
                    </form> :
                        <form>
                            <div className="col-sm-8">
                                <div className="col-sm-2">
                                    <label className="control-label" htmlFor="PartA1">Part-A(1)</label>
                                    <div className="form-group">
                                        <input type="checkbox" checked={cbox1} onClick={(e) => handleCbox(e, 1)} />
                                    </div>
                                </div>
                                <div className="col-sm-2">
                                    <label className="control-label" htmlFor="PartA2">Part-A(2)</label>
                                    <div className="form-group">
                                        <input type="checkbox" defaultChecked={cbox2} onClick={(e) => handleCbox(e, 2)} />
                                    </div>
                                </div>
                                <div className="col-sm-2">
                                    <label className="control-label" htmlFor="PartB">Part-A(3)</label>
                                    <div className="form-group">
                                        <input type="checkbox" defaultChecked={cbox3} onClick={(e) => handleCbox(e, 3)} />
                                    </div>
                                </div>
                                <div className="col-sm-2">
                                    <label className="control-label" htmlFor="PartB">Part-A(4)</label>
                                    <div className="form-group">
                                        <input type="checkbox" defaultChecked={cbox4} onClick={(e) => handleCbox(e, 4)} />
                                    </div>
                                </div>
                                <div className="col-sm-2">
                                    <label className="control-label" htmlFor="PartC">Part-C</label>
                                    <div className="form-group">
                                        <input type="checkbox" defaultChecked={cbox5} onClick={(e) => handleCbox(e, 5)} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-2" >
                                <label className="control-label text-center" htmlFor="Part-A Color">Part-A Color</label>
                                <div className="form-group col-sm-12">
                                    <input type="color" list="presetColors1" className="form-control" onChange={e => setPartAColor(e.target.value)} defaultValue={partAColor} id="partAColor" />
                                    <datalist id="presetColors1">
                                        <option>#5e35b1</option>
                                        <option>#b1357d</option>
                                        <option>#3d35b1</option>
                                        <option>#35b137</option>
                                        <option>#b17d35</option>
                                        <option>#b13535</option>
                                        <option>#ffdd00</option>
                                    </datalist>
                                </div>
                            </div>
                        </form>}
                    {props.hpcFormat == 10 ? <HpcFoundational
                        studentName={props.studentName}
                        studentId={props.studentId}
                        cbox1={cbox1}
                        cbox2={cbox2}
                        cbox3={cbox3}
                        cbox4={cbox4}
                        partAColor={partAColor}
                        partBColor={partBColor}
                        classSectionId={props.classSectionId}
                        lstStudentPdf={props.lstStudentPdf}
                        basePathStudent={props.basePathStudent}
                        basePathActivity={props.basePathActivity}
                        imgPath={props.imgPath}
                        sliderKey={props.sliderKey}
                        cls={props.cls}
                        clsSection={props.clsSection}
                    /> :
                        props.hpcFormat == 30 ?
                        <HpcMiddle
                            studentName={props.studentName}
                            imgPath={props.imgPath}
                            studentId={props.studentId}
                            cbox1={cbox1}
                            cbox2={cbox2}
                            cbox3={cbox3}
                            cbox4={cbox4}
                            cbox5={cbox5}
                            partAColor={partAColor}
                            partBColor={partBColor}
                            classSectionId={props.classSectionId}
                            lstStudentPdf={props.lstStudentPdf}
                            basePathStudent={props.basePathStudent}
                            basePathActivity={props.basePathActivity}
                            sliderKey={props.sliderKey}
                            cls={props.cls}
                            clsSection={props.clsSection} />
                        :
                            <HpcPreperatory
                                studentName={props.studentName}
                                imgPath={props.imgPath}
                                studentId={props.studentId}
                                cbox1={cbox1}
                                cbox2={cbox2}
                                cbox3={cbox3}
                                cbox4={cbox4}
                                cbox5={cbox5}
                                partAColor={partAColor}
                                partBColor={partBColor}
                                classSectionId={props.classSectionId}
                                lstStudentPdf={props.lstStudentPdf}
                                basePathStudent={props.basePathStudent}
                                basePathActivity={props.basePathActivity}
                                sliderKey={props.sliderKey}
                                cls={props.cls}
                                clsSection={props.clsSection} />
                    }
                </div>
            </div>
        </div>
    );
};

export default HpcStudentSlider;
